import React from "react";

import type { EmailTemplateProps } from "./utils";
import { noMargin, requestButtonStyle } from "./utils";

export const PilotEmailTemplate: React.FC<EmailTemplateProps> = ({
  buttonColor,
  linkUrl,
  companyName,
  clientName,
}) => (
  <div id="email-template">
    <p>Dear {companyName},</p>
    <p>
      Thank you for your willingness to participate in our pilot with Codat Inc.
      (“Codat”). As per our discussion, I am sending you this email requesting
      you submit your suppliers&apos; information using the secure Codat
      information request link below. To do this, you will be asked to log in to
      your accounting or ERP software. {clientName} will not have access to your
      accounting or ERP software login details at any time in this process. As
      part of the Codat pilot onboarding process, you will see and must agree to
      important Terms & Conditions.
    </p>
    <p>
      Your completion of the supplier information will allow the following data
      to be shared with Codat, who will in turn allow us to view:
    </p>
    <ul>
      <li>
        Your company&apos;s basic details, including its address and contact
        details
      </li>
      <li>
        Your suppliers&apos; basic details, including their address and contact
        details
      </li>
      <li>
        Details of your transactions with these suppliers (payment methods, bill
        and payment amounts, payment terms)
      </li>
    </ul>
    <p>
      We will use this information to prepare your card program optimization
      opportunity.
    </p>
    <p>
      When you are ready to provide your supplier information, click the button
      below to begin.
    </p>
    <p>
      <a
        style={requestButtonStyle(buttonColor)}
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="complete-information-button"
      >
        Complete information request
      </a>
    </p>
    <p>{linkUrl}</p>
    <p>
      Please let me know if you have any questions or would like to know more.
    </p>
    <p style={noMargin}>
      <b>Revoking Access</b>
    </p>
    <p style={noMargin}>
      You have control of your information and can revoke {clientName}&apos;
      access at any time by either:
    </p>
    <p style={noMargin}>
      1. Removing access directly in your ERP/accounting software app management
      page.
    </p>
    <p style={noMargin}>OR</p>
    <p style={noMargin}>2. Contact me about revoking access.</p>
    <p>Note: Access will be revoked after 90 days.</p>
    <hr />
    <p>
      Codat may require pilot customers to execute certain documentation in
      conjunction with this pilot. If so, Codat will provide such documentation
      for such pilot customer&apos;s review and execution. Codat intends to
      securely retrieve financial information from pilot customers. Codat Inc.
      is a specialized data infrastructure provider, incorporated in Delaware
      with a registered address of 331 Park Ave South, 4th Floor, New York, NY
      10010, United States.
    </p>
  </div>
);
